import { api } from "./api";

function getUTM() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      const v = p.get(k);
      if (v) utm[k] = v;
    });
    if (Object.keys(utm).length) {
      localStorage.setItem("rawlove_utm", JSON.stringify(utm));
    }
    const stored = localStorage.getItem("rawlove_utm");
    return stored ? JSON.parse(stored) : utm;
  } catch {
    return {};
  }
}

export async function trackEvent(event, conversation_id = null, meta = null) {
  try {
    await api.post("/analytics/event", { event, conversation_id, utm: getUTM(), meta });
  } catch {
    /* analytics must never block UX */
  }
  // TikTok Pixel hook (configurable — no-op until pixel is injected)
  if (typeof window !== "undefined" && window.ttq && typeof window.ttq.track === "function") {
    try { window.ttq.track(event, meta || {}); } catch { /* ignore */ }
  }
}
